import { typedEntries } from '@soundxyz/utils/entries';
import { ErrorMessages } from '../../Shared/errors';
import { releaseInfoState, ReleaseInfoValidatableFields } from '../../Shared/fields';
import { clearReleaseInfoErrors } from '../../Shared/helpers';

export const validateReleaseInfo = () => {
  clearReleaseInfoErrors();

  const result = ReleaseInfoValidatableFields.safeParse(releaseInfoState.fields);

  if (!result.success) {
    result.error.issues.map(({ path, message }) => {
      if (path?.[0] === 'rewards' && path?.[1] != null && path?.[2] != null) {
        const fieldName = String(path[2]);

        const index = Number(path[1]);
        if (isNaN(index) || index < 0) {
          return;
        }

        if (index >= releaseInfoState.errors.rewards.length) {
          // Create missing objects if they don't exist
          for (let i = releaseInfoState.errors.rewards.length; i <= index; i++) {
            if (!releaseInfoState.errors.rewards[i]) {
              releaseInfoState.errors.rewards[i] = {};
            }
          }
        }

        const currentErrors = releaseInfoState.errors.rewards[index];
        if (currentErrors) {
          (currentErrors as { [key: string]: string })[fieldName] = message;
        }
      }

      if (path?.[0] === 'tempTrack') {
        const fieldName = String(path[1]);

        const currentErrors = releaseInfoState.errors.tempTrack;

        if (currentErrors) {
          (currentErrors as { [key: string]: string })[fieldName] = message;
        }
      }

      if (path?.[0] === 'goldenEggImages' && path?.[1] != null) {
        const index = Number(path[1]);
        if (isNaN(index) || index < 0) {
          return;
        }

        if (index >= releaseInfoState.errors.goldenEggImages.length) {
          // Create missing values if they don't exist
          for (let i = releaseInfoState.errors.goldenEggImages.length; i <= index; i++) {
            if (!releaseInfoState.errors.goldenEggImages[i]) {
              releaseInfoState.errors.goldenEggImages[i] = null;
            }
          }
        }

        if (message === 'Expected object, received null') {
          releaseInfoState.errors.goldenEggImages[index] =
            ErrorMessages.goldenEggImages.required_error;
        } else {
          releaseInfoState.errors.goldenEggImages[index] = message;
        }
      }
    });

    typedEntries(result.error.flatten().fieldErrors).forEach(([key, value]) => {
      if (key === 'rewards' || key === 'goldenEggImages' || key === 'tempTrack') return;
      releaseInfoState.errors[key] = value?.[0];
    });

    releaseInfoState.isValid = false;
    return;
  }
  releaseInfoState.isValid = true;
  return result.data;
};
